import { Text } from '@chakra-ui/react';

import CoverageConsentModal from './CoverageConsentModal';

interface HabitationalUnderwritingApprovalModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (consentMethod: number) => void;
  newLimit: string;
  threshold: string;
  isLoading?: boolean;
}

const HabitationalUnderwritingApprovalModal = ({
  isOpen,
  onClose,
  onConfirm,
  newLimit,
  threshold,
  isLoading = false,
}: HabitationalUnderwritingApprovalModalProps) => {
  const warningContent = (
    <>
      <Text fontSize="sm" fontWeight="600" mb={2}>
        Underwriting approval required
      </Text>
      <Text fontSize="sm">
        Selecting a liability limit below{' '}
        <Text as="span" fontWeight="600">
          {threshold}
        </Text>{' '}
        requires underwriting approval. You are selecting{' '}
        <Text as="span" fontWeight="600">
          {newLimit}
        </Text>
        .
      </Text>
    </>
  );

  return (
    <CoverageConsentModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      isLoading={isLoading}
      title="Underwriting Approval Required"
      warningContent={warningContent}
      attestationText="I acknowledge that this liability limit selection requires underwriting approval and have obtained the necessary approval before proceeding."
    />
  );
};

export default HabitationalUnderwritingApprovalModal;
